if (!customElements.get('video-player')) {
  customElements.define('video-player', class VideoPlayer extends HTMLElement {
    constructor() {
      super();
      this.videoElement = this.querySelector('[data-video]');
      this.playButton = this.querySelector('[data-play-button]');
      this.clickOverlay = this.querySelector('[data-overlay]');
    }

    connectedCallback() {
      if (!this.videoElement) return;

      this.initPlaybackControls();
      this.initFullscreenHandlers();
      this.initStateListeners();
    }

    initPlaybackControls() {
      const checkIsMobileDevice = () => window.innerWidth <= 768;

      const handleTogglePlayback = (event) => {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        
        if (this.videoElement.paused) {
          this.videoElement.play();
          if (checkIsMobileDevice()) {
            this.requestVideoFullscreen();
          }
        } else {
          this.videoElement.pause();
        }
      };

      if (this.playButton) {
        this.playButton.addEventListener('click', handleTogglePlayback);
      }
      
      if (this.clickOverlay) {
        this.clickOverlay.addEventListener('click', handleTogglePlayback);
      }

      this.videoElement.addEventListener('click', handleTogglePlayback);
    }

    initStateListeners() {
      const activeClass = 'is-playing';

      this.videoElement.addEventListener('play', () => {
        this.classList.add(activeClass);
        this.videoElement.controls = true; 
      });

      this.videoElement.addEventListener('pause', () => {
        this.classList.remove(activeClass);
        this.videoElement.controls = false;
      });

      this.videoElement.addEventListener('ended', () => {
        this.classList.remove(activeClass);
        this.videoElement.controls = false;
      });
    }

    requestVideoFullscreen() {
      const video = this.videoElement;
      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.webkitEnterFullscreen) {
        video.webkitEnterFullscreen();
      } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen();
      }
    }

    initFullscreenHandlers() {
      const handleExit = () => {
        if (!document.fullscreenElement && !this.videoElement.paused) {
          this.videoElement.pause();
        }
      };
      document.addEventListener('fullscreenchange', handleExit);
      this.videoElement.addEventListener('webkitendfullscreen', () => {
        this.videoElement.pause();
      });
    }
  });
}